import script from "./EditBankInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./EditBankInformation.vue?vue&type=script&setup=true&lang=js"

import "./EditBankInformation.vue?vue&type=style&index=0&id=442ff156&scoped=true&lang=css"

import exportComponent from "/home/runner/work/payments-cmglobals/payments-cmglobals/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-442ff156"]])

export default __exports__